// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"346":"books","915":"bookDetail"}[chunkId] + "." + {"346":"8b53d677","915":"73ddad0a"}[chunkId] + ".css";
};